<div
        class="flex flex-col items-center justify-center gap-3"
        [class.text-red-500]="leaderboardRow.bestComparison < 0"
        [class.text-green-500]="leaderboardRow.bestComparison >= 0"
>
    <span>{{leaderboardRow.bestValueToCompare }}</span>
    <span>{{leaderboardRow.bestComparison > 0 ? leaderboardRow.bestComparison : leaderboardRow.bestComparison * -1 | number:'1.0-0'}}%</span>
</div>
